import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SearchableItem } from './searchable-item.model';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.scss'],
   providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableDropdownComponent),
      multi: true
    }
  ]
})
export class SearchableDropdownComponent implements OnChanges {
  selectedItem: any | undefined = '' 
  filterValue: string | undefined = '';
  @Input() items: SearchableItem[] ;
  @Output() emitedValue = new EventEmitter();
  filteredItems: SearchableItem[] = [];
  @Input() placeholder: string = ''

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() { }
  writeValue(value: any): void {
    this.selectedItem = value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredItems = [...this.items];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  customFilterFunction() {
      const query = this.filterValue?.toLowerCase();
      this.filteredItems = this.items?.filter(item => item.name.toLowerCase().includes(query));
  }
  resetFunction() {
       this.filterValue = '';
       this.filteredItems = [...this.items];
  }
  changeSelectedItem(item){
     this.selectedItem = item;
     this.onChange(item?.value); 
     this.emitedValue.emit(item); //optional, for other logic
  }
   clearSelection() {
    this.selectedItem = undefined; 
    this.onChange(this.selectedItem); 
  }
}
